/* Ember theme - light vanilla JS (nav state, mega-menu, mobile menu, gallery, qty). */
(function () {
  'use strict';

  /* Sticky nav: solid bar after a little scroll. */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Desktop Shop mega-menu with a small close delay so the cursor can travel onto the panel. */
  var nav = document.querySelector('.nav');
  var shopItem = document.querySelector('.nav__item--shop');
  var mega = document.querySelector('.shop-mega');
  if (nav && shopItem && mega) {
    var t = null;
    var open = function () { if (t) { clearTimeout(t); } nav.classList.add('shop-open'); };
    var close = function () { t = setTimeout(function () { nav.classList.remove('shop-open'); }, 120); };
    shopItem.addEventListener('mouseenter', open);
    shopItem.addEventListener('mouseleave', close);
    shopItem.addEventListener('focusin', open);
    mega.addEventListener('mouseenter', open);
    mega.addEventListener('mouseleave', close);
  }

  /* Mobile menu overlay. */
  var toggle = document.querySelector('.nav__toggle');
  var mobile = document.querySelector('.mobile-menu');
  if (toggle && mobile) {
    var openM = function () { mobile.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var closeM = function () { mobile.classList.remove('is-open'); document.body.style.overflow = ''; };
    toggle.addEventListener('click', openM);
    mobile.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', closeM); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeM(); } });
  }

  /* Product gallery: thumbnail swap + arrow scroll. */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    var strip = g.querySelector('[data-gallery-strip]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        if (main && src) { main.setAttribute('src', src); }
        var alt = btn.getAttribute('data-alt');
        if (main && alt) { main.setAttribute('alt', alt); }
        thumbs.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
    var prev = g.querySelector('[data-gallery-prev]');
    var next = g.querySelector('[data-gallery-next]');
    if (strip && prev) { prev.addEventListener('click', function () { strip.scrollBy({ left: -240, behavior: 'smooth' }); }); }
    if (strip && next) { next.addEventListener('click', function () { strip.scrollBy({ left: 240, behavior: 'smooth' }); }); }
  });

  /* Quantity stepper. */
  document.querySelectorAll('[data-qty]').forEach(function (w) {
    var input = w.querySelector('input');
    var minus = w.querySelector('[data-qty-minus]');
    var plus = w.querySelector('[data-qty-plus]');
    if (minus && input) { minus.addEventListener('click', function () { var v = parseInt(input.value, 10) || 1; input.value = Math.max(1, v - 1); }); }
    if (plus && input) { plus.addEventListener('click', function () { var v = parseInt(input.value, 10) || 1; input.value = v + 1; }); }
  });
})();
